import React from 'react';
import EstimatesTemplates from './EstimatesTemplates';
import './estimates.scss';
import './EstimatesTemplates.scss';

function EstimatesTemplatesPage() {
  return (
    <div className="estimates-container p-3 min-vh-100 bg-secondary bg-opacity-10">
        <EstimatesTemplates />
    </div>
  );
}

export default EstimatesTemplatesPage;
